export default {
	title: '图谱分析工具',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		save: '保存',
		cancel: '取消',
		confirm: '确定'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '操作成功',
		selectDeleteWarning: '请选择要删除的记录',
		operateSuccess: '操作成功',
		requiredFieldCannotBeEmpty: '必填项不能为空'
	},
	form: {
		name: '名称',
		placeholder: {
			name: '请输入名称'
		}
	},
	table: {
		id: 'ID',
		name: '图谱类型名称',
		toolCode: '编码',
		icon: '图标',
		sort: '排序'
	},
	widgetForm: {
		id: 'ID',
		name: '名称',
		toolCode: '编码',
		icon: '图标',
		sort: '排序',
		remark: '备注',
		gridLayout: '格栅布局',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		placeholder: {
			id: '请输入 ID',
			name: '请输入名称',
			toolCode: '请输入编码',
			icon: '请选择图标',
			sort: '请输入排序',
			remark: '请输入备注'
		}
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定'
	}
}
